import { DropdownMenu } from "@/clientWeb/components/ui/dropdown-menu";
import { incrementDropdowns, decrementDropdowns } from "../hooks/utils";

interface TrackedDropdownMenuProps {
  children: React.ReactNode;
}

export function TrackedDropdownMenu({ children }: TrackedDropdownMenuProps) {
  return (
    <DropdownMenu
      // Not modal, deliberately.
      //
      // A modal Radix menu sets `document.body { pointer-events: none }` while
      // it is open and puts the previous value back when it closes — but the
      // "previous value" lives in ONE module-level variable shared by every
      // layer in the app (`originalBodyPointerEvents` in
      // react-dismissable-layer). Open a second modal layer while that is in
      // flight and the variable is re-captured as "none", so the final restore
      // writes "none" back to the body and leaves it there. Every click in the
      // meeting is dead after that: the control bar, the back button, the way
      // out of full screen.
      //
      // Entering full screen from this menu is exactly that interleaving — the
      // `fullscreenchange` handler closes panels and fires a resize while the
      // menu is still tearing down. These are control-bar menus: they have
      // nothing to trap focus for and nothing to scroll-lock, so the modality
      // was only ever buying the bug.
      modal={false}
      onOpenChange={(open) => {
        if (open) {
          incrementDropdowns();
        } else {
          decrementDropdowns();
        }
      }}
    >
      {children}
    </DropdownMenu>
  );
}
